var path = 'areas/configuration/overview/index.html';
var html = "<div> <h3>About this Octopus Deploy server</h3> <p>Welcome to Octopus Deploy! Just getting started? The checklist below will help you get up and running.</p> <ul class=\"checklist fa-ul\"> <li ng-repeat=\"item in checklist\"><i class=\"fa-li fa\" ng-class=\"{'fa-check-square': item.completed, 'fa-square': !item.completed, 'text-success': item.completed, 'text-primary': !item.completed}\"></i><span ng-bind-html-unsafe=item.html></span></li> </ul> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/overview/index.html
// module id = 746
// module chunks = 1